import { Component, OnInit } from '@angular/core';
import { ConstantsService } from '../services/constants.service';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';

@Component({
  selector: 'app-admin-failed',
  templateUrl: './admin-failed.component.html',
  styleUrls: ['./admin-failed.component.scss']
})
export class AdminFailedComponent implements OnInit {
  public isLoading = false;
  public videos;

  skeltonArray;
  p: number = 1;
  videoTitle: any;
  isRetrying = false;
  public errorAlert = false;
  public errorAlertMessage = '';
  public successAlert = false;
  public successAlertMessage = '';
  constructor(
    public constants: ConstantsService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
  ) {
    var skelton = [
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG
    ]
    this.skeltonArray = skelton;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.load();
  }
  load = async () => {
    this.isLoading = true;
    let failedVideos
    const params = [
      { param: '{object}', value: this.constants.GET_LIST },
      { param: '{id1}', value: this.constants.FAILED_TXT },
      { param: '{id2}', value: this.constants.GET_LIST },
    ];
    this.dataService.getData(this.urlConstants.getUri(this.urlConstants.getList, params)).subscribe((data: any) => {
      this.videos = data["Items"]
      this.isLoading = false;
    }, (error) => {
      console.log("Error in fetching failed videos", error);
    })
  }
  closeErrorAlert() {
    this.errorAlert = false;
  }
  closeSuccessAlert() {
    this.successAlert = false;
  }

  copyVideoName(video) {
    navigator.clipboard.writeText(video.videoName).then(() => {
      this.successAlert = true;
      this.successAlertMessage = "Video name copied to clipboard!";
      setTimeout(() => {
        this.successAlert = false;
        this.successAlertMessage = "";
      }, 3000);
    })
  }

  retryVideo(video) {
    if (!this.isRetrying) {
      const videoIndex = this.videos.findIndex(v => v.videoName === video.videoName);
      if (videoIndex !== -1) {
        this.videos[videoIndex].isRetrying = true;
        this.isRetrying = true;
        const params = [
          { param: '{actionName}', value: 'asyncVideoUploadToVimeo' }
        ]
        const postdata = {
          ...this.videos[videoIndex]
        }
        this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).subscribe((data: any) => {
          if (data.status == "success") {
            this.videos.splice(videoIndex, 1);
            this.successAlert = true;
            this.successAlertMessage = "Video uploaded to vimeo successfully";
            setTimeout(() => {
              this.successAlert = false;
              this.successAlertMessage = "";
            }, 3000);
          }
          this.isRetrying = false;

        }, (error) => {
          console.log("Error in retrying video upload", error);
          this.isRetrying = false;
          this.errorAlert = true;
          const index = this.videos.findIndex(v => v.videoName === video.videoName);
          if (index !== -1) {
            this.videos[index].isRetrying = false;
          }
          this.errorAlertMessage = "Error in retrying video upload";
          setTimeout(() => {
            this.errorAlert = false;
            this.errorAlertMessage = "";
          }, 3000);
        })
      }
    }

  }
}

